import { motion } from 'framer-motion'
import { BarChart3 } from 'lucide-react'
import { PageHeader, fadeUp } from '@personic/shared'
import { buildBreadcrumbs } from '@/config/routes'
import { useCalibration } from '@/hooks/useCalibration'

export default function Dimensions() {
  const { isLoading } = useCalibration()
  const breadcrumbs = buildBreadcrumbs('/settings/calibration/dimensions')

  return (
    <div>
      <PageHeader
        title="Calibration Dimensions"
        description="Configure personality dimension weights and sensitivity thresholds."
        breadcrumbs={breadcrumbs}
      />

      <motion.div variants={fadeUp} initial="hidden" animate="visible" className="max-w-4xl">
        <div className="rounded-xl border border-warm-200 bg-white p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-copper-50 flex items-center justify-center">
              <BarChart3 className="w-5 h-5 text-copper-500" />
            </div>
            <h2 className="font-heading font-semibold text-midnight-800">Dimension Configuration</h2>
          </div>
          {isLoading ? (
            <div className="animate-pulse space-y-3">
              {[1, 2, 3, 4, 5].map(i => (
                <div key={i} className="h-10 bg-warm-100 rounded" />
              ))}
            </div>
          ) : (
            <p className="text-sm text-warm-500 text-center py-6">
              Dimension configuration uses your tenant's calibration profile. Adjust individual dimension weights to fine-tune profiling for your use case.
            </p>
          )}
        </div>
      </motion.div>
    </div>
  )
}
